module.exports = __webpack_public_path__ + "img/PositiveMedia-white.9271d515.png";